import * as addFilesToCourse from "@itslearning/atlas/files/addFilesToCourse";
import config from "../config";
import { endpoints } from "../constants.js";
import { addElementsToPlan } from "../api";

const updateFileStatus = (file, planId, columnId, planFilesStatusStore) =>
    planFilesStatusStore.updateFileStatus(file, planId, columnId);

export const addGoogleDriveFiles = async (
    googleDriveSettings,
    planId,
    columnId,
    planResources,
    planFilesStatusStore
) => {
    try {
        const elements = await addFilesToCourse.addGoogleDriveFiles(
            hasMember(planResources, "courseId") ? planResources.courseId : config.courseId,
            hasMember(planResources, "folderId") ? planResources.folderId : config.folderId,
            googleDriveSettings.pickerUrl,
            true, // selectMultiple
            hasMember(planResources, "fileValidationSettings") ? planResources.fileValidationSettings : config.fileValidationSettings,
            config.antiForgeryHeaderSettings,
            endpoints.addCloudFilesToCourseFolder(planId),
            file => updateFileStatus(file, planId, columnId, planFilesStatusStore)
        );

        await onFilesAddedToCourse(elements, planId, columnId);
    } catch (error) {
        onError(error);
    }
};

export const addOneDriveFiles = async (
    oneDriveSettings,
    planId,
    columnId,
    planResources,
    planFilesStatusStore
) => {
    try {
        const elements = await addFilesToCourse.addOneDriveFiles(
            hasMember(planResources, "courseId") ? planResources.courseId : config.courseId,
            hasMember(planResources, "folderId") ? planResources.folderId : config.folderId,
            oneDriveSettings.pickerUrl,
            true, // selectMultiple
            hasMember(planResources, "fileValidationSettings") ? planResources.fileValidationSettings : config.fileValidationSettings,
            config.antiForgeryHeaderSettings,
            hasMember(planResources, "fileRepoSettings") ? planResources.fileRepoSettings : config.fileRepoSettings,
            endpoints.addCloudFilesToCourseFolder(planId),
            endpoints.addFileRepoFilesToCourseFolder(planId),
            file => updateFileStatus(file, planId, columnId, planFilesStatusStore),
            deepHasMember(planResources, "cloudSettings", "enableUploadFromOneDrive")
                ? planResources.cloudSettings.enableUploadFromOneDrive
                : config.cloudSettings.enableUploadFromOneDrive,
            deepHasMember(planResources, "cloudSettings", "enableLinkingFromOneDrive")
                ? planResources.cloudSettings.enableLinkingFromOneDrive
                : config.cloudSettings.enableLinkingFromOneDrive
        );

        await onFilesAddedToCourse(elements, planId, columnId);
    } catch (error) {
        onError(error);
    }
};

export const addRecentCloudFile = async (
    cloudFile,
    planId,
    columnId,
    planResources,
    planFilesStatusStore
) => {
    try {
        const elements = await addFilesToCourse.addRecentCloudFile(
            hasMember(planResources, "courseId") ? planResources.courseId : config.courseId,
            hasMember(planResources, "folderId") ? planResources.folderId : config.folderId,
            cloudFile,
            hasMember(planResources, "fileValidationSettings") ? planResources.fileValidationSettings : config.fileValidationSettings,
            config.antiForgeryHeaderSettings,
            endpoints.addCloudFilesToCourseFolder(planId),
            file => updateFileStatus(file, planId, columnId, planFilesStatusStore)
        );

        await onFilesAddedToCourse(elements, planId, columnId);
    } catch (error) {
        onError(error);
    }
};

export const addLocalFiles = async (
    files,
    planId,
    columnId,
    planResources,
    planFilesStatusStore
) => {
    try {
        const elements = await addFilesToCourse.addLocalFiles(
            hasMember(planResources, "courseId") ? planResources.courseId : config.courseId,
            hasMember(planResources, "folderId") ? planResources.folderId : config.folderId,
            files,
            hasMember(planResources, "fileValidationSettings") ? planResources.fileValidationSettings : config.fileValidationSettings,
            config.antiForgeryHeaderSettings,
            hasMember(planResources, "fileRepoSettings") ? planResources.fileRepoSettings : config.fileRepoSettings,
            endpoints.addFileRepoFilesToCourseFolder(planId),
            file => updateFileStatus(file, planId, columnId, planFilesStatusStore)
        );

        await onFilesAddedToCourse(elements, planId, columnId);
    } catch (error) {
        onError(error);
    }
};

const onFilesAddedToCourse = (elements, planId, columnId) => {
    return addElementIdsToPlan(
        elements.map(e => e.elementId),
        planId,
        columnId
    );
};

export async function addElementIdsToPlan(elementIds, planId, columnId, partialUpdate = true) {
    const result = await addElementsToPlan(elementIds, planId, columnId, partialUpdate);

    window.postMessage(
        JSON.stringify({
            messageName: "SendElementIdToCourseFeature",
            relatedEntityId: planId,
            customId: columnId
        }),
        "*"
    );

    return result;
}

const onError = error => console.error(error);

const hasMember = (obj, member) => obj && Object.prototype.hasOwnProperty.call(obj, member);
const deepHasMember = (obj, member1, member2) => hasMember(obj, member1) && hasMember(obj[member1], member2);
